export var FeatureToggle;

(function (FeatureToggle) {
  var _a;

  var Features;

  (function (Features) {
    Features["CrmInteractions"] = "CrmInteractions";
    Features["CrmSales"] = "CrmSales";
    Features["TrendAnalysis"] = "TrendAnalysis";
    Features["Drilldown"] = "Drilldown";
  })(Features = FeatureToggle.Features || (FeatureToggle.Features = {}));

  var FeatureSlug;

  (function (FeatureSlug) {
    FeatureSlug["CrmSales"] = "ENTITY_CRM_SALES";
    FeatureSlug["CrmInteractions"] = "ENTITY_CRM_INTERACTIONS";
    FeatureSlug["TrendAnalysis"] = "TREND_ANALYSIS";
  })(FeatureSlug = FeatureToggle.FeatureSlug || (FeatureToggle.FeatureSlug = {}));

  FeatureToggle.FEATURE_MAP_BY_SLUG = (_a = {}, _a[FeatureSlug.CrmSales] = Features.CrmSales, _a[FeatureSlug.CrmInteractions] = Features.CrmInteractions, _a);
  FeatureToggle.RESTRICTED_FEATURE_SLUGS = [FeatureSlug.CrmSales, FeatureSlug.CrmInteractions];
})(FeatureToggle || (FeatureToggle = {}));